import type { ReactNode } from 'react';

/** Пустой экран должен объяснять, что происходит, а не просто молчать. */
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-8 py-14 text-center">
      {icon && <div className="text-muted opacity-60">{icon}</div>}
      <p className="text-[16px] font-medium">{title}</p>
      {hint && <p className="text-muted max-w-xs text-[14px]">{hint}</p>}
      {action}
    </div>
  );
}
